module.exports = __webpack_public_path__ + "img/title_undraw_a_day_off_re_hedl.b22c16e2.svg";